import { inject } from "@angular/core";
import { Routes } from "@angular/router";
import { Matcher } from "@zaeper/angular-core-lib";
import { SaveLocalstoragePageComponent } from "../pages/save-localstorage-page/save-localstorage-page.component";
import { AppOutletComponent } from "../outlets/app-outlet/app-outlet.component";
import { authenticationGuardInjectionToken } from "./guards/session/authentication-guard-injection-token";
import {
  dictionaryResolverServiceInjectionToken
} from "../services/dictionary/dictionary-resolver-service-injection-token";
import { currentUserResolverInjectionToken } from "./resolvers/session/current-user-resolver-injection-token";
import { StartOverviewPageComponent } from "../pages/start-overview-page/start-overview-page.component";
import {
  ApplicationsOverviewPageComponent
} from "../pages/applications-overview-page/applications-overview-page.component";
import { AppDetailPageComponent } from "../pages/app-detail-page/app-detail-page.component";
import { CanDeactivateGuard } from "./guards/page/can-deactivate.guard";
import { languageResolverServiceInjectionToken } from "../services/language/languageResolverServiceInjectionToken";
import { appResolverInjectionToken } from "./resolvers/application/app/app-resolver-injection-token";
import { appPageResolverInjectionToken } from "./resolvers/application/app/app-page-resolver-injection-token";
import { launcherPageResolverInjectionToken } from "./resolvers/application/launcher/launcher-page-resolver-injection-token";
import { launcherResolverInjectionToken } from "./resolvers/application/launcher/launcher-resolver-injection-token";
import { widgetPageResolverInjectionToken } from "./resolvers/application/widget/widget-page-resolver-injection-token";
import { widgetResolverInjectionToken } from "./resolvers/application/widget/widget-resolver-injection-token";
import { AppVersionDetailPageComponent } from "../pages/app-version-detail-page/app-version-detail-page.component";
import {
  LauncherDetailPageComponent
} from "../pages/launcher-detail-page/launcher-detail-page.component";
import {
  WidgetDetailPageComponent
} from "../pages/widget-detail-page/widget-detail-page.component";
import {
  appVersionPageResolverInjectionToken
} from "./resolvers/application-version/app-version/app-version-page-resolver-injection-token";
import {
  launcherVersionPageResolverInjectionToken
} from "./resolvers/application-version/launcher-version/launcher-version-page-resolver-injection-token";
import {
  widgetVersionPageResolverInjectionToken
} from "./resolvers/application-version/widget-version/widget-version-page-resolver-injection-token";
import {
  DeveloperLicensePageComponent
} from "../pages/developer-license-page/developer-license-page.component";
import {
  PaymentOverviewPageComponent
} from "../pages/payment-overview-page/payment-overview-page.component";
import {
  ConnectOnboardingPageComponent
} from "../pages/connect-onboarding-page/connect-onboarding-page.component";
import { MfaSettingsPageComponent } from "../pages/mfa-settings-page/mfa-settings-page.component";
import { RegistryRoutingModule } from "@zaeper/angular-registry-lib";

const availableLanguages: string[] = [
  "de", "en"
];

export const routes: Routes = [
  {
    path: "",
    redirectTo: `${ availableLanguages[0] }`,
    pathMatch: "full"
  }, {
    path: "save-localstorage",
    pathMatch: "full",
    component: SaveLocalstoragePageComponent
  }, {
    path: "",
    component: AppOutletComponent,
    canActivateChild: [ () => inject( authenticationGuardInjectionToken ).isLoggedIn() ],
    pathMatch: "prefix",
    children: [
      {
        matcher: Matcher.matchLanguage( availableLanguages ),
        pathMatch: "prefix",
        resolve: {
          language: languageResolverServiceInjectionToken,
          dictionaries: dictionaryResolverServiceInjectionToken,
          currentUser: () => inject( currentUserResolverInjectionToken ).getCurrentUser()
        },
        children: [
          {
            path: "",
            pathMatch: "full",
            component: StartOverviewPageComponent
          }, {
            path: "license",
            pathMatch: "full",
            component: DeveloperLicensePageComponent
          }, {
            path: "payment-overview",
            pathMatch: "full",
            component: PaymentOverviewPageComponent
          }, {
            path: "connect",
            pathMatch: "full",
            component: ConnectOnboardingPageComponent
          }, {
            path: "registry",
            loadChildren: () => RegistryRoutingModule
          }, {
            path: "mfa-settings",
            pathMatch: "full",
            component: MfaSettingsPageComponent
          }, {
            path: "applications",
            pathMatch: "full",
            component: ApplicationsOverviewPageComponent,
            resolve: {
              appPage: appPageResolverInjectionToken,
              launcherPage: launcherPageResolverInjectionToken,
              widgetPage: widgetPageResolverInjectionToken
            }
          }, {
            path: "app",
            pathMatch: "prefix",
            children: [
              {
                pathMatch: "full",
                matcher: Matcher.matchId( "appId" ),
                component: AppDetailPageComponent,
                canDeactivate: [ CanDeactivateGuard ],
                resolve: {
                  app: appResolverInjectionToken,
                  appVersions: appVersionPageResolverInjectionToken
                }
              }, {
                pathMatch: "prefix",
                matcher: Matcher.matchId( "appId" ),
                children: [
                  {
                    path: "version",
                    pathMatch: "prefix",
                    children: [
                      {
                        pathMatch: "full",
                        matcher: Matcher.matchId( "appVersionId" ),
                        component: AppVersionDetailPageComponent,
                        canDeactivate: [ CanDeactivateGuard ]
                      }
                    ]
                  }
                ]
              },
            ]
          }, {
            path: "launcher",
            pathMatch: "prefix",
            children: [
              {
                pathMatch: "full",
                matcher: Matcher.matchId( "launcherId" ),
                component: LauncherDetailPageComponent,
                canDeactivate: [ CanDeactivateGuard ],
                resolve: {
                  launcher: launcherResolverInjectionToken,
                  launcherVersions: launcherVersionPageResolverInjectionToken
                }
              }
            ]
          }, {
            path: "widget",
            pathMatch: "prefix",
            children: [
              {
                pathMatch: "full",
                matcher: Matcher.matchId( "widgetId" ),
                component: WidgetDetailPageComponent,
                canDeactivate: [ CanDeactivateGuard ],
                resolve: {
                  widget: widgetResolverInjectionToken,
                  widgetVersions: widgetVersionPageResolverInjectionToken
                }
              }
            ]
          }
        ]
      }
    ]
  }
];
